export default __webpack_public_path__ + "static/media/Vijayavani1.a79c0e0c.png";